import { reactive, computed, type Ref } from 'vue';

interface UseTinyMCEWordCountReturn {
  totalWords: Ref<number>;
  wordCounts: Record<string, number>;
  updateCount: (key: string, count: number) => void;
}

export function useTinyMCEWordCount(
    wordLimit: number,
    fieldKeys: string[] = []
): UseTinyMCEWordCountReturn {

  const wordCounts = reactive<Record<string, number>>(
      fieldKeys.reduce((acc, key) => {
        acc[key] = 0;
        return acc;
      }, {} as Record<string, number>)
  );

  const totalWords = computed<number>(() => {
    return Object.values(wordCounts).reduce((sum, count) => sum + (count || 0), 0);
  });

  const updateCount = (key: string, count: number) => {
    if (key in wordCounts) {
      wordCounts[key] = count;
    }
  };

  return {
    totalWords,
    wordCounts,
    updateCount,
  };
}
